import classNames from "classnames";
import styles from "../index.module.less";

export default function UserAgreement({ className = "" }) {
  return (
    <div className={classNames(styles.agreement, className)}>
      <span>注册登录即代表同意</span>
      <a
        className={styles.link}
        href="/about/disclaimer"
        target="_blank"
        rel="noreferrer nofollow"
      >
        《花瓣用户协议》
      </a>
      <a
        className={styles.link}
        href="/about/disclaimer?activeKey=1"
        target="_blank"
        rel="noreferrer nofollow"
      >
        《花瓣隐私政策》
      </a>
    </div>
  );
}
